
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gqwzE", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.6f56ec18.js.map
